// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"57c76eb8","612":"5970b1a6","616":"0aa5a44c","831":"ae779607","845":"6a7744b7"}[chunkId] + ".chunk.css";
};